import getUser from "../../services/getters/base_getters/get_user";
import loadUserAccount from "../../actions/react_query/user/load_user_account";
import useAvvirSelector from "../../services/component_helpers/component_effects/use_avvir_selector";
import useQueryWithState from "../use_query_with_state";

const useUserAccount = () => {
  const user = useAvvirSelector(getUser);
  return useQueryWithState(["useUserAccount"], loadUserAccount, getUser, { enabled: !!user}, null);
};

export default useUserAccount;
